import React, { useEffect, useState, useRef } from 'react';
import { Navbar, Nav, Offcanvas } from 'react-bootstrap';
import './NavBar.css';

const NavBar = () => {
  const navbarRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);

  const handleScroll = () => {
    setScrollPosition(window.pageYOffset);
    if (scrollPosition > 30) {
      navbarRef.current.classList.add("navbar-scroll");
    } else {
      navbarRef.current.classList.remove("navbar-scroll");
    }
  };

  const handleNavLinkClick = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [scrollPosition]);

  return (
    <>
      <Navbar ref={navbarRef} expand="lg" className={`d-none d-lg-flex ${scrollPosition > 30 ? 'navbar-scroll' : ''}`}>
        <div className="container">
          <Navbar.Brand href="#inicio">
            <img src={`${process.env.PUBLIC_URL}/images/AlexDev.png`} alt="Logo de AlexDev" />
          </Navbar.Brand>
          <Nav className="ml-auto">
            <Nav.Link href="#inicio">Inicio</Nav.Link>
            <Nav.Link href="#services">Services</Nav.Link>
            <Nav.Link href="#portfolio">Portfolio</Nav.Link>
            <Nav.Link href="#about">About</Nav.Link>
            <Nav.Link href="#contact">Contacto</Nav.Link>
          </Nav>
        </div>
      </Navbar>

      <Navbar ref={navbarRef} expand="lg" className={`d-lg-none ${scrollPosition > 30 ? 'navbar-scroll' : ''}`}>
        <div className="container">
          <Navbar.Brand href="#inicio">
            <img src={`${process.env.PUBLIC_URL}/images/AlexDev.png`} alt="Logo de AlexDev" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="offcanvasNavbar" onClick={() => setIsOpen(true)} style={{border: 'none'}}>
            <span style={{width: '30px', height: '2px', backgroundColor: '#fff', display: 'block', margin: '4px'}}></span>
            <span style={{width: '30px', height: '2px', backgroundColor: '#fff', display: 'block', margin: '4px'}}></span>
            <span style={{width: '30px', height: '2px', backgroundColor: '#fff', display: 'block', margin: '4px'}}></span>
          </Navbar.Toggle>

          <Offcanvas show={isOpen} onHide={() => setIsOpen(false)} placement='start' className="bg-dark">
            <Offcanvas.Header closeButton style={{backgroundColor: '#161616', justifyContent: 'end'}}>
              <Offcanvas.Title className="w-100 d-flex justify-content-center">
                <img src={`${process.env.PUBLIC_URL}/images/AlexDev.png`} alt="Logo de AlexDev" style={{width: '150px', height: 'auto'}} />
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="bg-dark">
              <Nav className="flex-column align-items-center justify-content-around h-100" style={{fontSize: '2rem'}}>
                <Nav.Link href="#inicio" onClick={handleNavLinkClick}>Inicio</Nav.Link>
                <Nav.Link href="#services" onClick={handleNavLinkClick}>Services</Nav.Link>
                <Nav.Link href="#portfolio" onClick={handleNavLinkClick}>Portfolio</Nav.Link>
                <Nav.Link href="#about" onClick={handleNavLinkClick}>About</Nav.Link>
                <Nav.Link href="#contact" onClick={handleNavLinkClick}>Contacto</Nav.Link>
              </Nav>
            </Offcanvas.Body>
          </Offcanvas>
        </div>
      </Navbar>
    </>
  );
};

export default NavBar;
